import { usePendingEntity } from '../../../../../hooks/fetchers/usePendingEntity/usePendingEntity';
import Loading from '../../../../commons/Loading/Loading';
import ProfileLayout from '../../../../commons/ProfileLayout/ProfileLayout';
import ProfileHeader from '../ProfileHeader/ProfileHeader';
import ProfileEntityForm from './ProfileEntityForm/ProfileEntityForm';

export default () => {
  const { data: pendingEntity, isLoading } = usePendingEntity();

  return (
    <ProfileLayout>
      <ProfileHeader />
      <section className="profile__main-row">
        {isLoading ? (
          <Loading />
        ) : (
          <section className="profile__main-row">
            <ProfileEntityForm disabled={Boolean(pendingEntity)} {...{ pendingEntity }} />
          </section>
        )}
      </section>
    </ProfileLayout>
  );
};
